import { createFileRoute } from '@tanstack/react-router';
import { AdminQuoteReviewPage } from '@/features/admin/admin-quote-review-page';

export const Route = createFileRoute('/sales/quotes/$id/')({
  component: SalesQuoteReviewRoute,
});

function SalesQuoteReviewRoute() {
  const { id } = Route.useParams();
  return <AdminQuoteReviewPage quoteId={id} backHref="/sales/quotes" portalBase="/sales" />;
}
